import gql from "graphql-tag";
import { WalletFragment } from "../fragments/wallet.fragment";

export const FIND_OR_CREATE_DAILY_ATTENDANCE_WALLET = gql`
  mutation ($userId: String!) {
    findOrCreateDailyAttendanceCreditWallet(userId: $userId) {
      ...WalletInfo
    }
  }
  ${WalletFragment}
`;
